import { AlertCircle } from "lucide-react";

/**
 * A sign-in failure, stated plainly.
 *
 * `role="alert"` so it is announced rather than silently appearing — a cashier
 * who mistyped a PIN is not looking at this part of the screen.
 */
export function AuthError({ message }: { message: string | null }) {
  if (!message) return null;

  return (
    <div
      role="alert"
      className="flex items-start gap-2.5 rounded-control bg-danger-50 px-3.5 py-3 text-sm text-danger-700"
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0" aria-hidden />
      <span>{message}</span>
    </div>
  );
}
